import { useEffect } from 'react';

import Projects from '@/components/projects/Projects';

import classes from './ProjectsPage.module.scss';

const ProjectsPage = () => {
	useEffect(() => {
		document.title = 'ERP - My projects';
	}, []);

	return (
		<section className={classes.mainContainer}>
			<Projects />
		</section>
	);
};

export default ProjectsPage;
